(() => {
  const bodySelector = '.template-product-origins-black-v1';

  const initGalleryCounter = (section) => {
    const wrapper = section.querySelector('.product__media-list-wrapper');
    const slider = section.querySelector('.product__media-list');

    if (!wrapper || !slider || wrapper.querySelector('.ib-gallery-counter')) return;

    const slides = [...slider.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')];
    if (!slides.length) return;

    const counter = document.createElement('span');
    counter.className = 'ib-gallery-counter';
    counter.setAttribute('aria-live', 'polite');
    wrapper.append(counter);

    const update = () => {
      const active = slider.querySelector('.product__media-item.swiper-slide-active');
      const ariaLabel = active?.getAttribute('aria-label');
      const current = ariaLabel?.match(/^(\d+)\s*\/\s*(\d+)$/)?.[1]
        || String((slider.swiper?.realIndex || 0) + 1);
      counter.textContent = `${current} / ${slides.length}`;
    };

    update();
    slider.swiper?.on('slideChange', update);

    const observer = new MutationObserver(update);
    observer.observe(slider, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-label']
    });
  };

  const initSizeValidation = (section) => {
    const fieldset = section.querySelector('#SingleOptionSelector-0');
    const form = section.querySelector('form[data-type="add-to-cart-form"]');
    const errorWrapper = section.querySelector('.product-form__error-message-wrapper');
    const errorMessage = section.querySelector('.product-form__error-message');
    const config = section.querySelector('[data-ib-size-error]');

    if (!fieldset || !form || !errorWrapper || !errorMessage || !config) return;

    const radios = [...fieldset.querySelectorAll('input[type="radio"]')];
    const variantInput = form.querySelector('input[name="id"]');

    radios.forEach((radio) => {
      radio.checked = false;
      radio.removeAttribute('checked');
    });

    if (variantInput) variantInput.value = '';

    errorWrapper.id = 'IronbackSizeError';
    fieldset.setAttribute('aria-describedby', errorWrapper.id);

    const hideError = () => {
      errorWrapper.hidden = true;
      errorMessage.textContent = '';
      fieldset.removeAttribute('aria-invalid');
    };

    const showError = () => {
      errorMessage.textContent = config.dataset.ibSizeError;
      errorWrapper.hidden = false;
      fieldset.setAttribute('aria-invalid', 'true');
      fieldset.focus({ preventScroll: true });
      fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    radios.forEach((radio) => radio.addEventListener('change', hideError));

    form.addEventListener('submit', (event) => {
      if (fieldset.querySelector('input[type="radio"]:checked')) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      showError();
    }, true);
  };

  const initDescriptionLink = (section) => {
    const link = section.querySelector('.ib-description-summary__link');
    const fullDescription = document.querySelector('[id*="__content_tabs_"]');

    if (!link || !fullDescription) return;

    link.addEventListener('click', (event) => {
      event.preventDefault();
      fullDescription.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  const init = () => {
    const body = document.querySelector(bodySelector);
    const section = body?.querySelector('.product-section');

    if (!section || section.dataset.ibPdpInitialized === 'true') return;
    section.dataset.ibPdpInitialized = 'true';

    initGalleryCounter(section);
    initSizeValidation(section);
    initDescriptionLink(section);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
